import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../../Services/document.service';
import { ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { Response } from '@angular/http';

@Component({
  selector: 'app-document-member-form',
  template: require('./document-member-form.component.html'),
  styles: [require('./document-member-form.component.css')]
})
export class DocumentMemberFormComponent implements OnInit {

  memberId:number = 0
  my_documents:any[] = [];
  constructor(private route: ActivatedRoute,
              private documentService: DocumentService) { 

    route.params.subscribe( (p:any) => {
      if (p['id'])
        this.memberId = +p['id'];
      else
        this.memberId = 0;
    });

  }

  ngOnInit() {
      this._getAllMyDocuments();
  }

  private _getAllMyDocuments(){
    this.documentService.getMyDocuments(this.memberId).subscribe( res => {
        this.my_documents = res;
        // console.log(this.my_documents);
      });
  }

  refresh(){
    this._getAllMyDocuments();
  }

  downloadDocument(id:number){
    // console.log(id);
    this.documentService.downloadDocument(id).subscribe((res: Response) =>{
      if (res.headers){
        var header = "";
        header = res.headers.get('content-disposition') || "";
        var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
        var endIndex = header.indexOf(";", startIndex);
        var filename = header.substring(startIndex, endIndex);
        // console.log("filename: " + filename)
        saveAs(res.blob(), filename);
      }
    });
    
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/document-member-form/document-member-form.component.ts